<template>
  <footer class="site-footer" v-if="showFooter || dirPage">
    <CookieLaw buttonClass="btn btn-sm btn-primary cookie-law-button" theme="black"></CookieLaw>
    <div class="footer-content-grid">

      <div class="footer-column">
        <h5 class="footer-section-header">TULUM</h5>
        <ul class="footer-nav-list">
          <li class="nav-item">
            <router-link :to="{ path: '/#event-line' }">Event Line</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Today' }">Today</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Clubs' }">Nightclubs</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'BeachClubs' }">Beachclubs</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'PartyCalendar' }">Party Calendar</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'TulumClubsMap' }">Clubs Map</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'ClubsDirectory' }">Clubs Directory</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Brands' }">Production Brands</router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'TulumNye2025' }">New Year Festival</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">TOP CLUBS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/bagatelle-tulum' }">Bagatelle</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/bonbonniere-tulum' }">Bonbonniere</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/confessions-tulum' }">Confessions</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/gitano-tulum' }">Gitano</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/gitano-beach-tulum' }">Gitano Beach</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/ilios-restaurant-tulum' }">Ilios</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/mia-beach-club-tulum' }">Mia Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/papaya-playa' }">Papaya Playa</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/rosa-negra-tulum' }">Rosa Negra</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/taboo-tulum' }">Taboo Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/tantra-tulum' }">Tantra Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/vagalume-tulum' }">Vagalume Tulum</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/tulum-clubs/vesica-tulum' }">Vesica Tulum</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">PRODUCTION BRANDS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/brands/ancestral-soul-tulum' }">Ancestral Soul</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/day-zero-tulum' }">Day Zero</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/keinemusik-tulum' }">Keinemusik</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/mayan-warrior-tulum' }">Mayan Warrior</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/mystical-sunset-tulum' }">Mystical Sunset</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/set-underground-tulum' }">SET Underground</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/sinner-tulum' }">Sinner</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/summerians-ibiza-tulum' }">Summerians</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/ten-ibiza-tulum' }">Ten Ibiza</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/tehmplo-tulum' }">Tehmplo</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/zamna-on-the-beach' }">Zamna On The Beach</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/brands/zamna-tulum' }">Zamna Tulum</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">RESOURCES</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ name: 'Today' }">Tulum Today</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'TulumDjSchedule' }">DJ Schedule</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Blog' }">Blog</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Community' }">Community</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'Search' }">Search</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'TulumNightLife' }">Nightlife Guide</router-link></li>
          <li class="nav-item"><a href="https://www.instagram.com/tulum.party" target="_blank" rel="noopener">Instagram</a></li>
          <li class="nav-item"><router-link :to="{ name: 'Faq' }"> FAQS</router-link></li>
          <li class="nav-item">
            <a target="_blank" rel="noopener noreferrer" href="https://imgix.cosmicjs.com/b71976d0-e281-11eb-b4d6-4f771ba4265e-TulumPartyAviso-Privacidad.pdf">
              Aviso Privacidad
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">
          <router-link :to="{ path: '/cancun-clubs' }">CANCUN</router-link>
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/mun-nightclub-cancun' }">MUN</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/coco-bongo-cancun' }">Coco Bongo Cancun</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/confessions-cancun' }">Confessions Cancun</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/cancun-clubs/taboo-cancun' }">Taboo Cancun</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">
          <router-link :to="{ path: '/playa-del-carmen-clubs' }">PLAYA DEL CARMEN</router-link>
        </h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/coco-bongo-playa-del-carmen' }">Coco Bongo PDC</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/ilios-playa-del-carmen' }">Ilios PDC</router-link></li>
          <li class="nav-item"><router-link :to="{ path: '/playa-del-carmen-clubs/martina-beach-club-playa-del-carmen' }">Martina</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">OTHER LOCATIONS</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><a href="https://www.cabo.party" target="_blank" rel="noopener">LOS CABOS</a></li>
          <li class="nav-item"><router-link :to="{ name: 'CancunClubs' }">CANCUN</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'PDCClubs' }">PLAYA DEL CARMEN</router-link></li>
        </ul>
      </div>

      <div class="footer-column">
        <h5 class="footer-section-header">OTHER SERVICES</h5>
        <ul class="footer-nav-list">
          <li class="nav-item"><router-link :to="{ name: 'ConciergeServices' }"> Concierge Services</router-link></li>
          <li class="nav-item"><router-link :to="{ name: 'WeddingPlanning' }"> Wedding Planners</router-link></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom-branding text-center">
      <img v-lazy="tulumPartyLogo" height="15" width="105" class="centered-logo" alt="tulum.party logo">
      <small class="tagline">PLAN A | SIDE B</small>
    </div>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';
import { mapState } from "vuex";

export default {
  name: 'ContentFooter', // Added name for the component
  components: { CookieLaw },
  computed: { // Corrected computed syntax
    ...mapState({ // Spread mapState directly into computed
      showFooter: (state) => state.showFooter,
    })
  },
  props: ['dirPage'],
  data() { // Corrected data syntax
    return {
      tulumPartyLogo: 'https://imgix.cosmicjs.com/3acdf350-9b87-11ee-b34c-99d1d89e42eb-tp-logo-40pt.png?w=105&h=15&fit=clamp',
    };
  },
};
</script>

